/* The projects hub. Markup and classes ported verbatim from artifact.html; the projects
   themselves now come from the server instead of browser storage. */

import { $, esc, fmt, shortDate } from "../util.js";
import { paintIcons } from "../icons.js";
import { api } from "../api.js";
import { toast } from "../toast.js";
import { state } from "../state.js";
import { projectBadge } from "../logos.js";

const PCOLORS = ["pv", "pm", "pt", "pa"];

export async function renderHome({ onOpenProject }) {
  let projects = [];
  try {
    projects = (await api.projects()).projects;
  } catch (err) {
    toast(err.message);
  }

  /* Guests manage projects exactly like anyone else; signing up is what keeps them across
     devices rather than what unlocks the feature. */
  let html =
    '<div class="pnew"><div style="font-size:13px;font-weight:700;display:flex;align-items:center;gap:7px"><i data-ic="plus" style="color:var(--violet)"></i>New project</div>' +
    '<input id="np-name" placeholder="Project name — e.g. vedaroots.com" maxlength="48">' +
    '<button class="btn" id="np-create" style="align-self:flex-start"><i data-ic="folder" style="width:13px;height:13px"></i>Create project</button></div>';

  html += projects.map((p, i) => {
    const cls = PCOLORS[i % PCOLORS.length];
    const badges = p.summary
      ? '<span class="pill" style="color:var(--magenta);background:var(--magenta-soft)">' + fmt(p.summary.conv) + ' conversational</span>' +
        '<span class="pill" style="color:var(--teal);background:var(--teal-soft)">' + p.summary.share + '% share</span>'
      : '<span class="pill" style="color:var(--amber);background:var(--amber-soft)">awaiting upload</span>';
    const count = p.summary ? " - " + fmt(p.summary.totalQ) + " queries" : " - no data yet";
    return '<div class="pcard ' + cls + '" data-pid="' + p.id + '">' +
      '<button class="del" data-del="' + p.id + '" title="Delete project">&#10005;</button>' +
      '<div class="pn">' + projectBadge(p.name, { domain: p.domain }) + esc(p.name) + "</div>" +
      '<div class="pd">' + shortDate(p.createdAt) + count + "</div>" +
      '<div class="ps">' + badges + "</div></div>";
  }).join("");

  $("pgrid").innerHTML = html;
  paintIcons($("pgrid"));

  const create = async () => {
    const name = $("np-name").value.trim();
    if (!name) { toast("Give the project a name"); return; }
    $("np-create").disabled = true;
    try {
      const { project } = await api.createProject(name);
      toast('Project "' + name + '" created - add your Queries.csv');
      onOpenProject(project);
    } catch (err) {
      toast(err.message);
    } finally {
      $("np-create").disabled = false;
    }
  };
  $("np-create").addEventListener("click", create);
  $("np-name").addEventListener("keydown", e => { if (e.key === "Enter") create(); });

  $("pgrid").querySelectorAll("[data-del]").forEach(el => el.addEventListener("click", async e => {
    e.stopPropagation();
    try {
      await api.deleteProject(el.dataset.del);
      toast("Project deleted");
      renderHome({ onOpenProject });
    } catch (err) {
      toast(err.message);
    }
  }));

  $("pgrid").querySelectorAll("[data-pid]").forEach(el => el.addEventListener("click", () => {
    const project = projects.find(p => p.id === el.dataset.pid);
    if (project) onOpenProject(project);
  }));

  return projects;
}
